import { useState, useEffect } from 'react';
import { getPageBySlug } from '../services/appService';


const usePage = (slug) => {
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) {
            setLoading(false);
            return;
        }

        let cancelled = false;

        const load = async () => {
            try {
                setLoading(true);
                const data = await getPageBySlug(slug);

                if (!cancelled) {
                    setPage(data);
                    setError(data ? null : 'Page not found.');
                }
            } catch (err) {
                if (!cancelled) {
                    setError('Failed to load page.');
                    console.error('[usePage]', err);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();

        return () => {
            cancelled = true;
        };
    }, [slug]);

    return { page, loading, error };
};

export default usePage;
